<template>
  <el-container class="is-vertical" id="main-container">
    <AppHeader/>
    <el-container>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<style lang="scss">
  @use '@/assets/common.scss' as *;

  body{
    margin: 0;
    font-family: Helvetica, Arial, sans-serif;

    @media #{$media-large-screen} {
      height: 100vh;
    }
  }

  @media #{$media-large-screen} {
    #main-container {
      height: 100vh;

      .el-container {
        min-height: 100px;

        .el-main {
          display: flex;
        }
      }
    }
  }

  #main-container .el-main {
    padding: 0;
  }

</style>

<script>
// @ is an alias to /src
import AppHeader from '@/components/AppHeader';

export default {
  name: 'app',
  components: {
    AppHeader,
  },
  data() {
    return {
      windowHeight: 0,
    };
  },
};
</script>
